/**
 * Cuerpo del `PATCH /api/mirror-models/:id` y paso de la ficha al formulario.
 *
 * El esquema del servidor exige números enteros en las medidas y `null` (no cadena vacía) en lo
 * opcional; construirlo aquí, con test, evita el 400 que solo aparece al guardar.
 */
export interface FormModelo {
  name: string; familyId: string; description: string; shape: string;
  widthMm: string; heightMm: string; thicknessMm: string;
  ledType: string; kelvin: string; powerW: string; notes: string;
  isCustom: boolean; active: boolean;
}

export interface ModeloBase {
  name: string; familyId: string | null; description: string | null; shape: string;
  widthMm: number; heightMm: number; thicknessMm: number;
  ledType: string | null; kelvin: number | null; powerW: number | null;
  notes: string | null; isCustom: boolean; active: boolean;
}

const numero = (valor: string): number => {
  const n = Number(String(valor).replace(',', '.'));
  return Number.isFinite(n) ? n : 0;
};

export function aFormulario(model: ModeloBase): FormModelo {
  return {
    name: model.name,
    familyId: model.familyId ?? '',
    description: model.description ?? '',
    shape: model.shape ?? 'rectangular',
    widthMm: String(model.widthMm ?? 0),
    heightMm: String(model.heightMm ?? 0),
    thicknessMm: String(model.thicknessMm ?? 5),
    ledType: model.ledType ?? '',
    kelvin: model.kelvin == null ? '' : String(model.kelvin),
    powerW: model.powerW == null ? '' : String(model.powerW),
    notes: model.notes ?? '',
    isCustom: model.isCustom,
    active: model.active
  };
}

export function buildModelPatch(form: FormModelo) {
  return {
    name: form.name.trim(),
    familyId: form.familyId || null,
    description: form.description.trim() || null,
    shape: form.shape,
    widthMm: Math.round(numero(form.widthMm)),
    heightMm: Math.round(numero(form.heightMm)),
    thicknessMm: Math.round(numero(form.thicknessMm)) || 5,
    ledType: form.ledType.trim() || null,
    kelvin: form.kelvin.trim() ? Math.round(numero(form.kelvin)) : null,
    powerW: form.powerW.trim() ? numero(form.powerW) : null,
    notes: form.notes.trim() || null,
    isCustom: form.isCustom,
    active: form.active
  };
}


/**
 * ¿Hay que recargar el formulario con los datos del servidor?
 *
 * Solo al abrirse y al cambiar de modelo. Mientras el panel está abierto **no**: la ficha se vuelve
 * a pedir sola (un `bom.activated` de cualquier usuario por SSE, o guardar otra cosa en la misma
 * pantalla) y reiniciar el formulario en ese momento borraría lo que el usuario está escribiendo.
 */
export function debeReiniciarFormulario(estado: {
  open: boolean;
  abiertoPrevio: boolean;
  modelIdActual: string | null;
  modelIdIniciado: string | null;
}): boolean {
  if (!estado.open) return false;
  if (!estado.abiertoPrevio) return true;
  return estado.modelIdActual !== estado.modelIdIniciado;
}
